import React from 'react';
import styles from './ReorderButtons.module.css';

type ReorderButtonsProps = {
  onMoveUp: () => void;
  onMoveDown: () => void;
  canMoveUp: boolean;
  canMoveDown: boolean;
  className?: string;
};

const ReorderButtons: React.FC<ReorderButtonsProps> = ({
  onMoveUp,
  onMoveDown,
  canMoveUp,
  canMoveDown,
  className = ''
}) => {
  return (
    <div className={`${styles.reorderButtons} ${className}`}>
      <button
        className={styles.reorderButton}
        onClick={onMoveUp}
        disabled={!canMoveUp}
        title="Move up"
      >
        ▲
      </button>
      <button
        className={styles.reorderButton}
        onClick={onMoveDown}
        disabled={!canMoveDown}
        title="Move down"
      >
        ▼
      </button>
    </div>
  );
};

export default ReorderButtons;

